import {UpdatePlaylistSchema} from "@repo/shared";

import {functionHookFactory} from "../factories/functionHookFactory";

export const useUpdatePlaylist = functionHookFactory(
  "updatePlaylist",
  UpdatePlaylistSchema,
);
